/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FireblocksAssetInfo } from './fireblocksAssetInfo';

/**
 * Deposit info DTO
 */
export interface DepositInfoDto {
  fireblocksAsset: Array<FireblocksAssetInfo>;
}
